module.exports = {
  AMBIO: 'Ambio Wireless Scale',
};
